
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { activateBusWithPlatformFee } from '../../Services/Operations/ProductAPI';

const PlatformFeeModal = ({ bus, onClose, onActivated }) => {
  const { token } = useSelector(state => state.user);
  const [platformFee, setPlatformFee] = useState({
    type: 'fixed',
    value: 0,
    applicableOn: 'per_ticket'
  });
  const [remarks, setRemarks] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  console.log("PlatformFeeModal rendered with bus:", bus);

  const handleSubmit = async () => {
    if (platformFee.value <= 0) {
      toast.error('Platform fee value must be greater than 0');
      return;
    }

    if (platformFee.type === 'percentage' && platformFee.value > 100) {
      toast.error('Percentage cannot exceed 100%');
      return;
    }

    setIsSubmitting(true);

    try {
      const payload = {
        platformFee: {
          type: platformFee.type,
          value: platformFee.value,
          applicableOn: platformFee.applicableOn
        },
        remarks: remarks || `Bus activated with ${platformFee.type === 'fixed' ? '₹' + platformFee.value : platformFee.value + '%'} platform fee`
      };

      const busId = bus._id || bus.busId || bus.id;
      
      console.log("Activating bus:", busId);
      console.log("Payload:", payload);

      const response = await activateBusWithPlatformFee(busId, payload, token);
      
      console.log("API Response:", response);

      if (response && response.success) {
        toast.success(response.message || 'Bus activated successfully with platform fee!');
        if (onActivated) onActivated();
        onClose();
      } else {
        toast.error(response?.message || 'Failed to activate bus');
      }
    } catch (error) {
      console.error('Error activating bus:', error);
      const errorMessage = error.response?.data?.message || error.message || 'Failed to activate bus';
      toast.error(errorMessage);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content platform-fee-modal" onClick={(e) => e.stopPropagation()} style={{ width: '90%', background: 'white', borderRadius: '12px' }}>
        <div className="modal-header" style={{ padding: '15px', borderBottom: '1px solid #eee', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h3 style={{ margin: 0 }}>Activate Bus & Set Platform Fee</h3>
          <button className="modal-close-btn" onClick={onClose} style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer' }}>×</button>
        </div>

        <div className="modal-body" style={{ padding: '20px' }}>
          <div className="bus-info-section" style={{ background: '#f8f9fa', padding: '15px', borderRadius: '8px', marginBottom: '20px' }}>
            <h4 style={{ marginTop: 0, marginBottom: '10px' }}>Bus Information</h4>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '10px' }}>
              <p style={{ margin: 0 }}><strong>Bus Name:</strong> {bus.busName}</p>
              <p style={{ margin: 0 }}><strong>Bus Number:</strong> {bus.busNumber}</p>
              <p style={{ margin: 0 }}><strong>Bus Type:</strong> {bus.busType}</p>
              <p style={{ margin: 0 }}><strong>Total Seats:</strong> {bus.totalSeats}</p>
            </div>
          </div>

          <div className="platform-fee-section">
            <h4 style={{ marginBottom: '5px' }}>Platform Fee Configuration</h4>
            <p style={{ fontSize: '12px', color: '#888', marginBottom: '15px' }}>Set the platform fee that will be charged on each booking</p>

            <div className="form-group" style={{ marginBottom: '15px' }}>
              <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>Fee Type</label>
              <select
                value={platformFee.type}
                onChange={(e) => setPlatformFee({ ...platformFee, type: e.target.value })}
                style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }}
              >
                <option value="fixed">Fixed Amount (₹)</option>
                <option value="percentage">Percentage (%)</option>
              </select>
            </div>

            <div className="form-group" style={{ marginBottom: '15px' }}>
              <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>{platformFee.type === 'fixed' ? 'Fee Amount (₹)' : 'Fee Percentage (%)'}</label>
              <input
                type="number"
                min="0"
                step={platformFee.type === 'fixed' ? "1" : "0.1"}
                value={platformFee.value}
                onChange={(e) => setPlatformFee({ ...platformFee, value: parseFloat(e.target.value) || 0 })}
                style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }}
                placeholder={platformFee.type === 'fixed' ? "e.g., 50" : "e.g., 5"}
              />
            </div>

            <div className="form-group" style={{ marginBottom: '15px' }}>
              <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>Applicable On</label>
              <select
                value={platformFee.applicableOn}
                onChange={(e) => setPlatformFee({ ...platformFee, applicableOn: e.target.value })}
                style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }}
              >
                <option value="per_ticket">Per Ticket</option>
                <option value="per_seat">Per Seat</option>
                <option value="total_booking">Total Booking Amount</option>
              </select>
            </div>

            <div className="form-group" style={{ marginBottom: '15px' }}>
              <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>Remarks (Optional)</label>
              <textarea
                value={remarks}
                onChange={(e) => setRemarks(e.target.value)}
                placeholder="Add any remarks about this activation..."
                rows="3"
                style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px', resize: 'vertical' }}
              />
            </div>

            <div className="warning-box" style={{ display: 'flex', gap: '12px', padding: '12px', background: '#fff3e0', borderRadius: '8px', marginTop: '20px' }}>
              <span style={{ fontSize: '20px' }}>⚠️</span>
              <div style={{ fontSize: '13px', color: '#856404' }}>
                <strong>Important:</strong> Once activated, this bus will be available for booking immediately.
                Make sure all details are correct before proceeding.
              </div>
            </div>
          </div>
        </div>

        <div className="modal-footer" style={{ padding: '15px', borderTop: '1px solid #eee', display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
          <button className="btn-secondary" onClick={onClose} style={{ padding: '8px 16px', background: '#6c757d', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>
            Cancel
          </button>
          <button 
            className="btn-primary" 
            onClick={handleSubmit}
            disabled={isSubmitting || platformFee.value <= 0}
            style={{ padding: '8px 16px', background: platformFee.value <= 0 ? '#ccc' : '#28a745', color: 'white', border: 'none', borderRadius: '4px', cursor: platformFee.value <= 0 ? 'not-allowed' : 'pointer' }}
          >
            {isSubmitting ? 'Activating...' : 'Activate Bus'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PlatformFeeModal;